import { commonEnvironment } from './common.environment';

export const environment = {
  ...commonEnvironment,
  production: true,
  envName: 'prod',
  serverApiUrl: 'https://work.connect.wwag.ch',
  authServerUrl: 'https://idp.connect.wwag.ch',
  connectAppUrl: 'https://connect.wwag.ch',
  logoutUrl: 'https://work.connect.wwag.ch',
  zulip: {
    url: 'https://zulip.connect.wwag.ch',
    bucketUrl: '',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyAAoDkOehKQsnRVyJioGhQ9hsqZquZVnWc',
    authDomain: 'triarc-cloud.firebaseapp.com',
    projectId: 'triarc-cloud',
    storageBucket: 'triarc-cloud.appspot.com',
    messagingSenderId: '619412831763',
    appId: '1:619412831763:web:f02b0b6c90aece37c4c9e6',
  },
  wettstei: {
    ...commonEnvironment.wettstei,
    mlinkApiUrl: 'https://api.connect.wwag.ch',
  },
};
